import { gql } from 'apollo-boost';

export const UPDATE_APP_CONFIG_QUERY = gql`
  mutation Response($updateAppConfigInput: UpdateAppConfigInput!) {
    updateAppConfig(updateAppConfigInput: $updateAppConfigInput) {
      code
      httpStatus
      message
      details
    }
  }
`;
